'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.monitor.add', [])
  .controller('MonitorAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/monitor/add/index.js